<template>
  <div>
    <v-card>
      <v-card-title>
        <v-title>PBX Details</v-title>
      </v-card-title>
      <v-card-text py-0>
        <ValidationObserver ref="observer" v-slot="{ validate, reset }">
          <v-form pa-0 ma-0 v-model="valid">
            <v-container fluid pa-0>
              <v-layout row wrap>
                <v-flex xs4>
                  <ValidationProvider
                    v-slot="{ errors }"
                    name="customerNumber"
                    rules="required"
                  >
                    <v-text-field
                      name="customerNumber"
                      v-model="editItem.customerNumber"
                      label="Customer Number"
                      :error-messages="errors"
                      readonly
                      outlined
                      disabled
                    ></v-text-field>
                  </ValidationProvider>
                </v-flex>
                <v-flex xs4>
                  <ValidationProvider
                    v-slot="{ errors }"
                    name="hostedPbxDomain"
                    rules="required"
                  >
                    <v-text-field
                      name="hostedPbxDomain"
                      v-model="editItem.hostedPbxDomain"
                      label="Hosted PBX Domain"
                      :error-messages="errors"
                      editable
                      outlined
                    ></v-text-field>
                  </ValidationProvider>
                </v-flex>
                <v-flex xs4>
                  <ValidationProvider
                    v-slot="{ errors }"
                    name="customerEmail"
                    rules="required"
                  >
                    <v-text-field
                      name="customerEmail"
                      v-model="editItem.customerEmail"
                      label="Customer Email"
                      :error-messages="errors"
                      outlined
                    ></v-text-field>
                  </ValidationProvider>
                </v-flex>
              </v-layout>
              <v-layout row wrap>
                <v-flex xs8>
                  <ValidationProvider
                    v-slot="{ errors }"
                    name="companyName"
                    rules="required"
                  >
                    <v-text-field
                      name="companyName"
                      v-model="editItem.companyName"
                      label="Company Name"
                      :error-messages="errors"
                      readonly
                      outlined
                      disabled
                    ></v-text-field>
                  </ValidationProvider>
                </v-flex>
                <v-flex xs4>
                  <ValidationProvider
                    v-slot="{ errors }"
                    name="ubDealerId"
                    rules="required"
                  >
                    <v-text-field
                      name="ubDealerId"
                      v-model="editItem.ubDealerId"
                      label="UB Dealer ID"
                      :error-messages="errors"
                      readonly
                      outlined
                      disabled
                    ></v-text-field>
                  </ValidationProvider>
                </v-flex>
              </v-layout>
            </v-container>
          </v-form>
        </ValidationObserver>
      </v-card-text>
      <v-card-actions>
        <v-btn color="success" medium @click="syncUB()">Sync from UB</v-btn>
        <v-spacer></v-spacer>
        <v-btn
          color="error"
          medium
          @click="resetPassword()"
          v-if="editItem.hasLogin"
        >
          Reset Password
        </v-btn>
        <v-btn color="primary" medium @click="update()">Update</v-btn>
        <v-btn medium @click="close()">Close</v-btn>
      </v-card-actions>
      <v-snackbar v-model="snackbar" :timeout="5000" :color="snackColor">
        {{ message }}
      </v-snackbar>
    </v-card>
  </div>
</template>

<script>
import PbxDomains from '@/models/PbxDomains';
import { mapPbxDomainsFields } from '@/store/modules/pbxDomains';
import { createNamespacedHelpers } from 'vuex';
const { mapGetters: mapFeatureFlagGetters } = createNamespacedHelpers(
  `orders/featureFlag`
);
import { mapDistinctCustomersFields } from '@/store/modules/distinctCustomers';
const { mapActions: mapDistinctCustomersActions } =
  createNamespacedHelpers('distinctCustomers');

export default {
  name: 'PbxDialog',
  props: {
    pbxDomains: {
      type: Object,
    },
  },
  data: () => ({
    valid: true,
    editItem: new PbxDomains(),
    snackbar: false,
    snackColor: '',
    message: false,
  }),
  computed: {
    // ...mapPbxDomainsFields([])
    ...mapFeatureFlagGetters(['allFlags']),
  },
  methods: {
    ...mapDistinctCustomersActions(['updatePBXDomain']),
    update() {
      let vm = this;
      vm.$refs.observer.validate().then(result => {
        if (result) {
          let payload = new PbxDomains(vm.editItem);
          vm.$emit('update', payload);
          vm.reset();
        }
      });
    },
    resetPassword() {
      let vm = this;
      let payload = new PbxDomains(vm.editItem);
      vm.$emit('resetPassword', payload);
    },
    close() {
      let vm = this;
      vm.$emit('close', false);
      vm.reset();
    },
    reset() {
      let vm = this;
      vm.$refs.observer.reset();
    },
    syncUB() {
      let vm = this;
      vm.$dialog
        .confirm('Confirm Sync Hosted PBX Domain from UB?')
        .then(async () => {
          try {
            await vm.updatePBXDomain(vm.editItem.customerNumber)
            vm.toggleSnackbar('Successfuly synced from UB', 'success');
          } catch (error) {
            vm.toggleSnackbar(err.response.data.message, 'error');
          } finally {
            vm.$emit('refresh');
            vm.close();
          }
        })
        .catch((err) => {
          vm.toggleSnackbar(err.response.data.message, 'error');
        });
    },
    toggleSnackbar(message, color) {
      const vm = this;
      vm.snackbar = true;
      vm.snackColor = color;
      vm.message = message;
    },
  },
  watch: {
    pbxDomains(data) {
      this.editItem = { ...data };
    },
  },
};
</script>
